module.exports = __webpack_public_path__ + "assets/img/49@3x.440b0b07.png";